import request from '@/request/http'
import dt from './dt'
import { netUrl } from '../../configapi'
import axios from 'axios'

const api = {
    ...dt,
    login: data => { return request({ url: `cashierLogin`, data }) }, //登录
    getPhoneCode: data => { return request({ url: `getPhoneCode`, data }) },   //获取验证码
    registShopAccount: data => { return request({ url: `registShopAccount`, data }) },   //注册
    resetPassword: data => { return request({ url: `resetPassword`, data }) },   //重置密码
    DeskList: data => { return request({ url: `desk`, data }) },//
    shopPrintQcode: data => request({ url: `shopPrintQcode`, data }), // 获取桌位二维码
    addShopDesk: data => request({ url: `addShopDesk`, data, method: 'post' }), // 添加桌位
    deskCategoryList: data => request({ url: `deskCategoryList`, data, method: 'get' }), // 桌位类型列表
    updateShopDesk: data => request({ url: `updateShopDesk`, data, method: 'post' }), // 修改桌位信息
    deleteShopDesk: data => request({ url: `deleteShopDesk`, data, method: 'post' }), // 删除桌位
    staffBindDesk: data => request({ url: `staffBindDesk`, data, method: 'post' }), // 服务员绑定桌位

    ShopCategory: data => request({ url: `shopFoodCategory` + data.url, data: data.data, method: data.method }), // 修改菜品分类

    staff: data => request({ url: `staff` + data.url, data: data.data, method: data.method }), // 获取员工列表
    getCashierList: data => { return request({ url: `getCashierList`, data, method: 'get' }) }, //收银员列表
    getWaiterList: data => { return request({ url: `getWaiterList`, data, method: 'get' }) }, //服务员列表

    getArea: data => request({ url: `getArea`, data, method: 'get' }), // 获取店铺区域列表（包括区域下桌子）
    addArea: data => request({ url: `addArea`, data, method: 'post' }), // 新增店铺区域
    editArea: data => request({ url: `editArea`, data, method: 'post' }), // 编辑店铺区域
    delArea: data => request({ url: `delArea`, data, method: 'post' }), // 删除店铺区域

    OrderLists: (data, that) => {
        return request({
            url: `OrderLists`, data, method: 'get',
            cancelToken: new axios.CancelToken(function executor(c) { // 设置 cancel token
                that.source = c;
            })
        })
    },//订单列表
    getOrderDetail: (data, that) => {
        return request({
            url: `getOrderDetail`, data, method: 'get',
            cancelToken: new axios.CancelToken(function executor(c) { // 设置 cancel token
                that.source = c;
            })
        })
    },//订单详情
    showPreDetail: data => { return request({ url: `showPreDetail`, data, method: 'get' }) },//查看订单详情
    payNew: data => { return request({ url: `payNew`, data, method: 'post' }) },// 微信、支付宝支付
    printingOrder: data => { return request({ url: `printingOrder`, data }) },//打印
    getReturnFoodReason: data => { return request({ url: `getReturnFoodReason`, data, method: 'get' }) },//获取退菜原因
    updateEatNum: data => { return request({ url: `updateEatNum`, data, method: 'get' }) },//就餐人数
    placeAnOrder: data => { return request({ url: `newPlaceAnOrder`, data, method: 'get' }) },//收银端下单
    sendReturnFood: data => { return request({ url: `sendReturnFood`, data, method: 'post' }) },//申请退菜
    soundRecording: data => { return request({ url: `soundRecording`, data, method: 'post' }) },//上传录音
    refundMoney: data => { return request({ url: `refundMoney`, data, method: 'post' }) },//退款
    updateMember: data => { return request({ url: `updateMember`, data, method: 'post' }) },//修改选中会员
    getPayMethod: data => { return request({ url: `getPayMethod`, data, method: 'get' }) }, //订单获取支付方式
    getPayOrder: data => { return request({ url: `getPayOrder`, data, method: 'get' }) }, //退款列表

    updateShopInfo: data => request({ url: `updateShopInfo`, data, method: 'post' }), // 修改门店信息
    changeModel: data => request({ url: `changeModel`, data, method: 'post' }), // 切换模式（店长、普通）
    getServerInfo: data => { return request({ url: `getServerInfo`, data, method: 'get' }) },//获取客服联系方式
    getWorkerPermissions: data => { return request({ url: `getWorkerPermissions`, data, method: 'get' }) },//获取员工权限
    saveWorkerPermissions: data => { return request({ url: `saveWorkerPermissions`, data, method: 'post' }) },//保存员工权限
    getVesion: data => { return request({ url: `getVesion`, data, method: 'get' }) },//版本记录
    printSet: data => { return request({ url: `printSet`, data, method: 'post' }) },//设置是否打印做菜单
    getSmsSet: data => { return request({ url: `getSmsSet`, data, method: 'get' }) }, //会员短信配置
    setSmsConfig: data => { return request({ url: `setSmsConfig`, data, method: 'post' }) },//设置短信配置
    getSmsRecord: data => { return request({ url: `getSmsRecord`, data, method: 'get' }) }, //店铺短信记录

    memberList: data => { return request({ url: `memberList`, data, method: 'get' }) },// 查看会员列表
    editMember: data => { return request({ url: `editMember`, data, method: 'post' }) },// 修改会员详情
    editStatus: data => { return request({ url: `editStatus`, data, method: 'get' }) },// 修改会员状态
    expensesRecord: data => { return request({ url: `expensesRecord`, data, method: 'get' }) },// 会员消费记录列表
    rechargeRecord: data => { return request({ url: `rechargeRecord`, data, method: 'get' }) },// 会员充值记录列表
    resiveRecord: data => { return request({ url: `resiveRecord`, data, method: 'get' }) },// 会员调整记录列表
    getCardNum: data => { return request({ url: `getCardNum`, data, method: 'get' }) }, //新增会员获取卡号
    addMember: data => { return request({ url: `addMember`, data, method: 'post' }) }, //新增会员接口
    memberRecharge: data => { return request({ url: `memberRecharge`, data, method: 'post' }) },//会员充值接口

    memberTypeList: data => { return request({ url: `memberTypeList`, data, method: 'get' }) }, //会员类型列表
    addType: data => { return request({ url: `addType`, data, method: 'post' }) },//新增会员类型
    editType: data => { return request({ url: `editType`, data, method: 'post' }) },//编辑会员类型
    deleteMemberType: data => { return request({ url: `deleteMemberType`, data, method: 'post' }) },//删除会员类型

    newShopIncome: data => { return request({ url: `newShopIncome`, data, method: 'get' }) }, //营收概况列表
    saleReport: data => { return request({ url: `saleReport`, data, method: 'get' }) }, //销售明细列表
    dishRanking: data => { return request({ url: `dishRanking`, data, method: 'get' }) }, //菜单排行列表
    memberReport: data => { return request({ url: `newMemberReport`, data, method: 'get' }) },//会员概况列表
    payReport: data => { return request({ url: `payReport`, data, method: 'get' }) },//支付列表
    indexDishRanking: data => { return request({ url: `indexDishRanking`, data, method: 'get' }) }, //主页菜品排行
    businessTrends: data => { return request({ url: `businessTrends`, data, method: 'get' }) }, //主页营业趋势
    memberRanking: data => { return request({ url: `memberRanking`, data, method: 'get' }) }, //主页会员排行
    businessExpress: data => { return request({ url: `businessExpress`, data, method: 'get' }) }, //主页营业快报

    sweepMeal: data => { return request({ url: `sweepMeal`, data, method: 'get' }) }, //进入快餐
    emptyCarStaff: data => { return request({ url: `emptyCarStaff`, data, method: 'get' }) }, //清空购物车

    deleteShopFood: data => { return request({ url: `deleteShopFood`, data, method: 'get' }) },//删除菜品

    getDealCount: data => { return request({ url: `getDealCount`, data, method: 'get' }) },//获取待办条数

    netPrint: data => { return request({ url: netUrl + 'print', data, method: 'post' }) },//调用网络打印

    getPrintOrderWin: data => { return request({ url: `CronApi/getCronOrderPrint`, data, method: 'get' }) }, //新打印订单轮询接口(win)

    getVoiceCountWin: data => { return request({ url: `CronApi/getCronOrderCount`, data, method: 'get' }) }, //未读订单和语音轮询接口(win)
    

    // 添加一个统一的接口:
    getPaymentMethods: data => { return request({ url: `getPaymentMethods`, data, method: 'get' }) }, // 获取所有支付方式

    getCustomPaymentMethods: data => { return request({ url: `getCustomPaymentMethods`, data, method: 'get' }) }, // 获取自定义支付方式

    updatePaymentMethod: data => { return request({ url: `updatePaymentMethod`, data, method: 'post' }) }, // 更新支付方式
    
    addPaymentMethod: data => { return request({ url: `addPaymentMethod`, data, method: 'post' }) }, // 添加支付方式
    
    deletePaymentMethod: data => { return request({ url: `deletePaymentMethod`, data, method: 'post' }) }, // 删除支付方式

    getNewStaffRemain: data => request({ url: `getNewStaffRemain`, data, method: 'get' }), // 获取剩余可创建服务员账号数

    reverseCheckout: data => { return request({ url: `ReverseCheckout/doReverseCheckout`, data, method: 'post' }) }, //反结账
    getReverseCheckoutLogs: data => { return request({ url: `ReverseCheckout/getReverseCheckoutLogs`, data, method: 'get' }) }, //反结账日志
}

export default api



// WEBPACK FOOTER //
// ./src/request/api.js